export default {
  terms: {
    badge: 'TERMS OF USE',
    title: 'Terms of Service',
    updated: 'Last updated: September 2026',
    sections: [
      {
        title: '1. Purpose',
        blocks: [
          { type: 'p', text: 'These Terms of Service govern access to and use of the Limpia Sàrl website.' },
          { type: 'p', text: 'By accessing this site, the user acknowledges having read these terms and agrees to them.' },
          { type: 'p', text: 'The purpose of the site is to present the activities, services and offerings provided by Limpia Sàrl, as well as to allow visitors to get in touch with the company.' },
        ],
      },
      {
        title: '2. Information Presented on the Site',
        blocks: [
          { type: 'p', text: 'Limpia Sàrl strives to provide accurate, current and complete information about its services.' },
          { type: 'p', text: 'However, the information published on the site is provided for informational purposes and may be modified at any time without prior notice.' },
          { type: 'p', text: 'Limpia Sàrl does not guarantee that all information available on the site is constantly free of errors, complete or up to date.' },
        ],
      },
      {
        title: '3. Contact Requests and Quote Requests',
        blocks: [
          { type: 'p', text: 'The forms or contact details available on the site allow users to contact Limpia Sàrl or to request information about its services.' },
          { type: 'p', text: 'Sending a request through the site does not automatically constitute the conclusion of a contract.' },
          { type: 'p', text: 'Any service provision is subject to an agreement between Limpia Sàrl and the client and, where applicable, an offer or quote accepted by the client.' },
          { type: 'p', text: 'The information provided by the user must be accurate and complete in order to allow Limpia Sàrl to process the request correctly.' },
        ],
      },
      {
        title: '4. Intellectual Property',
        blocks: [
          { type: 'p', text: 'Unless otherwise indicated, all content on this site, including texts, logos, photographs, graphics, visual elements, designs and other content, is protected by the applicable provisions on intellectual property.' },
          { type: 'p', text: 'Any reproduction, modification, distribution, publication or commercial use of the site content without the prior authorization of Limpia Sàrl is prohibited, to the extent that such use is not authorized by law.' },
        ],
      },
      {
        title: '5. Use of the Site',
        blocks: [
          { type: 'p', text: 'The user agrees to use the site in a lawful manner and in accordance with these terms.' },
          { type: 'p', text: 'In particular, the following is prohibited:' },
          { type: 'li', text: 'using the site for illegal purposes;' },
          { type: 'li', text: 'attempting to gain unauthorized access to the systems or servers of the site;' },
          { type: 'li', text: 'transmitting malicious content or content likely to damage the site;' },
          { type: 'li', text: 'using the information on the site in a manner likely to infringe the rights of Limpia Sàrl or third parties.' },
        ],
      },
      {
        title: '6. Site Availability',
        blocks: [
          { type: 'p', text: 'Limpia Sàrl strives to keep its website accessible and functional.' },
          { type: 'p', text: 'However, access to the site may be temporarily interrupted, in particular for maintenance, updates, technical problems or circumstances beyond the control of Limpia Sàrl.' },
          { type: 'p', text: 'Limpia Sàrl does not guarantee permanent or uninterrupted availability of the site.' },
        ],
      },
      {
        title: '7. Links to Third-Party Sites',
        blocks: [
          { type: 'p', text: 'The site may contain links to websites or services operated by third parties.' },
          { type: 'p', text: 'These links are provided solely for convenience or informational purposes.' },
          { type: 'p', text: 'Limpia Sàrl exercises no control over the content, availability or privacy practices of these third-party sites and disclaims any responsibility for them.' },
        ],
      },
      {
        title: '8. Limitation of Liability',
        blocks: [
          { type: 'p', text: 'Within the limits permitted by applicable Swiss law, Limpia Sàrl disclaims all liability for direct or indirect damages that may result from the use or inability to use the website.' },
          { type: 'p', text: 'Limpia Sàrl cannot in particular be held liable for damages resulting from technical problems, service interruptions, malicious software, data loss or unauthorized access by third parties, unless otherwise provided by mandatory law.' },
          { type: 'p', text: 'The information published on the site does not constitute a contractual commitment regarding a particular service, unless expressly agreed otherwise.' },
        ],
      },
      {
        title: '9. Data Protection',
        blocks: [
          { type: 'p', text: 'The processing of personal data carried out in connection with the use of the site is governed by our Privacy Policy.' },
          { type: 'p', text: 'Users are invited to consult this policy in order to learn about the methods of collection, use, retention and protection of their personal data.' },
        ],
      },
      {
        title: '10. Changes to the Terms',
        blocks: [
          { type: 'p', text: 'Limpia Sàrl reserves the right to modify these Terms of Service at any time.' },
          { type: 'p', text: 'The version published on the site at the time of consultation is applicable.' },
        ],
      },
      {
        title: '11. Applicable Law',
        blocks: [
          { type: 'p', text: 'These Terms of Service are governed by Swiss law, subject to applicable mandatory legal provisions.' },
        ],
      },
      {
        title: '12. Jurisdiction',
        blocks: [
          { type: 'p', text: 'Subject to mandatory rules of jurisdiction provided by law, the competent courts at the registered office of Limpia Sàrl shall have jurisdiction over any dispute relating to the use of the website.' },
        ],
      },
      {
        title: '13. Contact',
        blocks: [
          { type: 'p', text: 'For any questions regarding these Terms of Service, you can contact:' },
          { type: 'p', text: 'Limpia Sàrl — Rte de Rosé 51, 1754 Avry-sur-Matran, Switzerland' },
          { type: 'p', text: 'Email: info@limpiasarl.ch' },
          { type: 'p', text: 'Phone: +41 26 436 10 83 & +41 79 887 72 52' },
        ],
      },
    ],
  },
};